/* eslint-disable ember/classic-decorator-hooks, ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { alias } from '@ember/object/computed';
import { action } from '@ember/object';
import { service } from '@ember/service';
import config from 'linced-app/config/environment';
import { optionAlias } from '@linc-technologies/linced-common/utils/options';

export default class XeroConnectButton extends Component {
  // Services
  @service
  fetch;

  @service
  options;

  @service
  session;

  @service
  store;

  @service
  toaster;

  @tracked
  loading = true;
  @tracked
  connected = false;
  @tracked
  error = false;

  @alias('session.activeSchool')
  schoolId;

  @optionAlias('finance:xero:enableXeroIntegration')
  xeroIntegrationEnabled;

  @tracked
  tenantName = '';

  @tracked
  redirecturl;

  init() {
    super.init(...arguments);
    let url = `${config.APP.apiHost}/xero/${config.APP.apiPath}/connectionurl/`;
    this.fetch
      .request(url)
      .then((redirecturl) => {
        this.redirecturl = redirecturl.url;
      })
      .catch(() => {
        this.loading = false;
        this.error = true;
      });
    let data = {
      schoolId: this.schoolId,
    };
    this.fetch
      .post(
        `${config.APP.apiHost}/xero/${config.APP.apiPath}/connections/:validate`,
        { data },
      )
      .then((resp) => {
        this.connected = true;
        this.tenantName = resp.tenantName;
        this.loading = false;
      })
      .catch(() => {
        this.loading = false;
        this.connected = false;
      });
  }

  @action
  disconnectXero() {
    this.fetch
      .delete(
        `${config.APP.apiHost}/xero/${config.APP.apiPath}/connections/${this.schoolId}`,
      )
      .then(() => {
        this.connected = false;
        this.toaster.success(`Xero Account disconnected successfully.`);
      })
      .catch(() => {
        this.toaster.success(`Failed to disconnect Xero Account.`);
      });
  }
}
